const api = {
  inspectorHiringForecast(id) {
    return `/InspectorHiringForecast/${id}`;
  },
  inspectorHiringForecastHistory(id) {
    return `/InspectorHiringForecast/${id}/History`;
  },
  inspectorHiringNotes(id) {
    return `/InspectorHiringForecast/${id}/Note`;
  }
};

export default api;